import { PageStore } from 'bernie-plugin-mobx';
import * as React from 'react';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { readFromCachedFragment } from 'utils/read-from-cached-fragment';

import { gql, useApolloClient } from '@apollo/client';

export const CACHED_PROPERTY_NAME_FRAGMENT = gql`
  fragment SummaryHeaderFragment on PropertyInfo {
    summary {
      name
    }
  }
`;

const setPageTitle = (page: PageStore, title: string) => {
  page.title = title;
  document.title = title;
};

export const useInfositePageTitleCacheRead = (currentHotel?: CurrentHotelStore, page?: PageStore) => {
  const client = useApolloClient();
  const propertyInfo = readFromCachedFragment(client, `PropertyInfo:${currentHotel?.hotelId}`, CACHED_PROPERTY_NAME_FRAGMENT);

  React.useEffect(() => {
    if (propertyInfo?.summary?.name) {
      page && setPageTitle(page, propertyInfo.summary.name);
    }
  });
};
